import { FC } from 'react';
import { Input } from 'src/components/Input';
import { Textarea } from 'src/components/Textarea';
import { Label } from 'src/components/Label';
import { FollowUpCommunicationForm } from 'src/pages/Automations/components/wizard/WizardContext';

interface EmailFieldsProps {
  followUpCall: FollowUpCommunicationForm;
  followUpCallIndex: number;
  onChange: (
    index: number,
    updatedCall: Partial<FollowUpCommunicationForm>,
  ) => void;
}

export const EmailFields: FC<EmailFieldsProps> = ({
  followUpCall,
  followUpCallIndex,
  onChange,
}) => {
  const handleChange = (field: string, value: string) => {
    onChange(followUpCallIndex, { [field]: value });
  };

  return (
    <div className="w-full rounded-xl border border-neutral-200 bg-neutral-0 p-3 space-y-4">
      <div className="w-full sm:w-full flex-shrink-0">
        <Label htmlFor={`follow-up-email-subject-${followUpCallIndex}`}>
          Subject
        </Label>
        <Input
          id={`follow-up-email-subject-${followUpCallIndex}`}
          type="text"
          placeholder="{first_name}, Sorry I Missed You – Let's Reschedule Our Call"
          value={followUpCall.emailSubject || ''}
          onChange={(e) => handleChange('emailSubject', e.target.value)}
          className="w-full"
        />
      </div>

      <div className="w-full sm:w-full flex-shrink-0">
        <Label htmlFor={`follow-up-email-body-${followUpCallIndex}`}>
          Body
        </Label>
        <Textarea
          id={`follow-up-email-body-${followUpCallIndex}`}
          placeholder="Hi {first_name}, This is Sarah from {company_name} writing to you..."
          rows={6}
          value={followUpCall.emailBody}
          required
          onChange={(e) => handleChange('emailBody', e.target.value)}
          className="w-full"
        />
      </div>
    </div>
  );
};
